import { HeaderButton } from '@/components/HeaderButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Dashboard from '@/images/Dashboard.svg';
import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import { AppRoutes } from '@/utils/types';
import { theme } from '@de-id/ui-components';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';

const StyledNew = styled.span`
    color: ${theme.colors.success[750]};
    background: #ddf7e7;
    border-radius: 4px;
    box-shadow: 0px 0px 12.444px 0px rgba(0, 0, 0, 0.1);
    text-align: center;
    font-size: 14px;
    margin-left: 8px;
    display: flex;
    padding: 0px 6px;
    justify-content: center;
    align-items: center;
    gap: 9px;
    max-height: 24px;
`;

export const InsightsButton = () => {
    const mixpanel = useAnalytics();
    const navigate = useNavigate();
    const { isAnonymous } = useAuth();

    if (isAnonymous) {
        return null;
    }

    const handleClick = () => {
        navigate(AppRoutes.Insights);
        mixpanel?.track('agent-insights', { event: 'click' });
    };

    return (
        <HeaderButton color="secondary" variant="outlined" id="agent-insights-btn" onClick={handleClick} aria-label="agent insights">
            <MaskedIcon src={Dashboard} size="24px" />
            Insights
            <StyledNew>New</StyledNew>
        </HeaderButton>
    );
};
